import {Component, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

export interface ToggleData {
  titles: {
    'left': string
    'right': string
  }
}

@Component({
  selector: 'clickatell-button-toggle',
  templateUrl: './clickatell-button-toggle.component.html',
  styleUrls: ['./clickatell-button-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: ClickatellButtonToggleComponent
    }
  ]
})
export class ClickatellButtonToggleComponent implements ControlValueAccessor {

  state = false;

  @Input()
  data: ToggleData;

  onChange = (state) => {};

  onTouched = () => {};

  touched = false;

  disabled = false;

  toggleState(state: boolean) {
    if(this.disabled) {
      return
    }
    this.markAsTouched()
    this.state = state
    this.onChange(this.state)
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(state: boolean): void {
    this.state = state
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }


}
